import { IonRow, IonCol, IonIcon, IonLabel } from "@ionic/react";
import classNames from "classnames/bind";
import { removeOutline, addOutline } from "ionicons/icons";
import React from "react";
import { Product } from "@core/types";
import styles from "./NewListViewProduct.module.scss";
import { useCartData } from "../../../../../providers/cartDataStore";
import { useProductCardActions } from "../../../../../providers/useProductActions";

interface CartQuantityControlProps {
  product: Product;
  type: "list-for-wish" | "newList";
}

const cx = classNames.bind(styles);

const CartQuantityControl = ({ product }: CartQuantityControlProps) => {
  const { cartProductsMap } = useCartData();
  const cartQuantity = cartProductsMap[product.id]?.quantity ?? 0;
  const { addToCart, removeProductFromCart } = useProductCardActions();
  const isDisabledToAdd = !product?.purchasable || cartQuantity === product.stockQuantity;

  return (
    <IonRow className={cx(styles.quantityCounter)} onClick={(e) => e.stopPropagation()}>
      <IonCol size="3" className="ion-text-center ion-no-padding" onClick={() => removeProductFromCart(product.id)}>
        {product.stockStatus === "instock" && (
          <IonIcon icon={removeOutline} className={cx(styles.icon, styles.removeQuantity)} />
        )}
      </IonCol>
      <IonCol size="6" className={cx("quantityValue")}>
        <IonLabel>{cartQuantity}</IonLabel>
      </IonCol>
      <IonCol
        size="3"
        className={cx("ion-text-center ion-no-padding", {
          disabled: isDisabledToAdd,
        })}
        onClick={() => addToCart(product)}
      >
        {product.stockStatus === "instock" && product.stockQuantity > cartQuantity && (
          <IonIcon icon={addOutline} className={cx(styles.icon, styles.addQuantity)} />
        )}
      </IonCol>
    </IonRow>
  );
};

export default CartQuantityControl;
